import PropTypes from 'prop-types';
import React from 'react';

const Public = ({children}) => {
  return <div className="main-content-public">{children}</div>;
};

Public.propTypes = {children: PropTypes.element};

export default Public;
